import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { baseSettingsHeader, baseSettingsLogin } from '../../slices/thunks';

const useLogoLoader = (logoType) => {
    const dispatch = useDispatch();
    const [logoSrc, setLogoSrc] = useState('');

    const selectorSettings = createSelector(
        state => state.Settings,
        result => ({
            login: result.itemSettingsLogin,
            header: result.itemSettingsHeader,
            isSettingsLoading: logoType === 'login' ? result.isSettingsLogin : result.isSettingsHeader,
            urlToRedirect: result.urlToRedirect 
        })
    );

    const { login, header, isSettingsLoading, urlToRedirect } = useSelector(selectorSettings);

    useEffect(() => {
        if (logoType === 'login') {
            dispatch(baseSettingsLogin());
        } else {
            dispatch(baseSettingsHeader());
        }
    }, [logoType]);

    useEffect(() => {
        if (logoType === 'login' && login) {
            setLogoSrc(login.login_logo);
        } else if (logoType === 'header' && header) {
            setLogoSrc(header.header_logo);
        }
    }, [login, header, logoType]);

    return { logoSrc, isSettingsLoading, urlToRedirect };
};

export default useLogoLoader;
